// extracted by mini-css-extract-plugin
export var borderTop = "_y-3";
export var linkIcon = "_y-5";
export var linkIconSm = "_y-6";
export var linkOutCard = "_y-7 _y-4";
export var linkRow = "_y-2";
export var pageContainer = "_y-1";
export var providerIcon = "_y-8";
export var roundedBorder = "_y-4";
export var settingsContent = "_y-0";